import { frontendURL } from '../../../helper/URLHelper';

const VoipCallsList = () => import('./VoipCallsList.vue');
const VoipCallReview = () => import('./VoipCallReview.vue');
const VoipLeadsList = () => import('./VoipLeadsList.vue');
const VoipLeadDetail = () => import('./VoipLeadDetail.vue');
const LeadsFocusMode = () => import('./LeadsFocusMode.vue');
const VoipAnalytics = () => import('./VoipAnalytics.vue');
const VoipSettingsPage = () => import('./settings/VoipSettingsPage.vue');
const VoipDevicesList = () => import('./devices/VoipDevicesList.vue');
const VoipDeviceDetail = () => import('./devices/VoipDeviceDetail.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/voip-calls'),
      name: 'voip_calls',
      component: VoipCallsList,
      meta: {
        permissions: ['administrator', 'agent', 'voip_view'],
        featureFlag: 'voip_calls',
      },
    },
    {
      path: frontendURL('accounts/:accountId/voip-calls/review'),
      name: 'voip_calls_review',
      component: VoipCallReview,
      meta: {
        permissions: ['administrator', 'agent', 'voip_view'],
        featureFlag: 'voip_calls',
      },
    },
    {
      path: frontendURL('accounts/:accountId/voip-calls/leads'),
      name: 'voip_leads',
      component: VoipLeadsList,
      meta: {
        permissions: ['administrator', 'agent', 'voip_view'],
        featureFlag: 'voip_calls',
      },
    },
    {
      path: frontendURL('accounts/:accountId/voip-calls/leads/focus'),
      name: 'voip_leads_focus',
      component: LeadsFocusMode,
      meta: {
        permissions: ['administrator', 'agent', 'voip_view'],
        featureFlag: 'voip_calls',
      },
    },
    {
      path: frontendURL('accounts/:accountId/voip-calls/leads/:contactId'),
      name: 'voip_lead_detail',
      component: VoipLeadDetail,
      props: true,
      meta: {
        permissions: ['administrator', 'agent', 'voip_view'],
        featureFlag: 'voip_calls',
      },
    },
    {
      path: frontendURL('accounts/:accountId/voip-calls/analitica'),
      name: 'voip_analytics',
      component: VoipAnalytics,
      meta: {
        permissions: ['administrator', 'agent', 'voip_view'],
        featureFlag: 'voip_calls',
      },
    },
    // Alias amigável — Desempenho consolida analítica/placar/conversão.
    {
      path: frontendURL('accounts/:accountId/voip-calls/desempenho'),
      name: 'voip_performance',
      component: VoipAnalytics,
      meta: {
        permissions: ['administrator', 'agent', 'voip_view'],
        featureFlag: 'voip_calls',
      },
    },
    {
      path: frontendURL('accounts/:accountId/voip-calls/configuracoes'),
      name: 'voip_calls_settings',
      component: VoipSettingsPage,
      meta: {
        permissions: ['administrator'],
        featureFlag: 'voip_calls',
      },
    },
    // Rota legada: números/conexões continuam acessíveis e apontam para a lista.
    {
      path: frontendURL('accounts/:accountId/voip-devices'),
      name: 'voip_devices',
      component: VoipDevicesList,
      meta: {
        permissions: ['administrator'],
        featureFlag: 'voip_calls',
      },
    },
    {
      path: frontendURL('accounts/:accountId/voip-devices/:deviceId'),
      name: 'voip_device_detail',
      component: VoipDeviceDetail,
      props: true,
      meta: {
        permissions: ['administrator'],
        featureFlag: 'voip_calls',
      },
    },
  ],
};
